import { render, staticRenderFns } from "./WineFormUpload.vue?vue&type=template&id=aee44ad4"
import script from "./WineFormUpload.vue?vue&type=script&lang=ts"
export * from "./WineFormUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports